import * as React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Box from "@mui/material/Box";
// import btcrise from "../../assets/btcrise.jpg";
import btcrise from "../../assets/trade.jpg";

const ExpandMore = styled((props) => {
	const { expand, ...other } = props;
	return <IconButton {...other} />;
})(({ theme }) => ({
	marginLeft: "auto",
	transition: theme.transitions.create("transform", {
		duration: theme.transitions.duration.shortest,
	}),
	variants: [
		{
			props: ({ expand }) => !expand,
			style: {
				transform: "rotate(0deg)",
			},
		},
		{
			props: ({ expand }) => !!expand,
			style: {
				transform: "rotate(180deg)",
			},
		},
	],
}));

export default function ReadAndMore() {
	const [expanded, setExpanded] = React.useState(false);

	const handleExpandClick = () => {
		setExpanded(!expanded);
	};

	return (
		<Box>
			<Card sx={{ width: "100%", margin: "auto" }}>
				<CardHeader
					avatar={
						<Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
							N
						</Avatar>
					}
					action={
						<IconButton sx={{ visibility: "hidden" }} aria-label="settings">
							<MoreVertIcon />
						</IconButton>
					}
					title="How we trade"
					subheader="Learn our trading pattern."
				/>
				{/* <CardMedia
					component="img"
					sx={{ height: 200, width: 200, objectFit: "cover" }}
					height="194"
					width="50%"
					image={btcrise}
					alt="Paella dish"
				/> */}
				<CardContent>
					<Typography variant="body2" sx={{ color: "text.secondary" }}>
						We approach trading in a unique way that sets us apart from
						conventional methods. Instead of relying solely on automated profit
						strategies, we employ a specialized trading technique designed to
						minimize losses. Additionally, we leverage leverage strategically to
						amplify our profits in every trade, ensuring a more effective and
						distinctive trading experience.
					</Typography>
				</CardContent>
				<CardActions disableSpacing>
					{/* <IconButton aria-label="add to favorites">
						<FavoriteIcon />
					</IconButton>
					<IconButton aria-label="share">
						<ShareIcon />
					</IconButton> */}
					<ExpandMore
						expand={expanded}
						onClick={handleExpandClick}
						aria-expanded={expanded}
						aria-label="show more">
						<ExpandMoreIcon />
					</ExpandMore>
				</CardActions>
				<Collapse in={expanded} timeout="auto" unmountOnExit>
					<CardContent>
						<Typography sx={{ marginBottom: 2 }}>Method:</Typography>
						<Typography sx={{ marginBottom: 2 }}>
							How we trade is what makes us different from the rest
						</Typography>
						<Typography sx={{ marginBottom: 2 }}>
							Our approach to trading is truly unique, distinguishing us from
							traditional methods. Unlike many traders who depend heavily on
							automated systems or standard strategies, we prioritize a
							customized and innovative trading philosophy. This allows us to
							adapt quickly to market changes and implement tactics that are
							specifically tailored to optimize our results.
						</Typography>
						<Typography sx={{ marginBottom: 2 }}>
							Instead of solely relying on automated profit strategies, we
							utilize a specialized trading technique focused on minimizing
							losses. This proactive approach helps us protect our capital and
							maintain consistent performance, even in volatile market
							conditions. By carefully managing risk and avoiding unnecessary
							setbacks, we ensure that our trading remains sustainable and
							resilient over time.
						</Typography>
						<Typography>
							To further enhance our profitability, we strategically use
							leverage to maximize gains in each trade. This calculated use of
							leverage allows us to amplify our potential returns without
							compromising safety. Combining our unique trading methods with
							prudent leverage management, we create a more effective and
							distinctive trading experience that aims to generate steady,
							long-term success.
						</Typography>
					</CardContent>
				</Collapse>
			</Card>
		</Box>
	);
}
